import React from 'react';

const SkeletonCard = ({ viewMode = 'grid' }) => {
  if (viewMode === 'list') {
    return (
      <div className="bg-card rounded-lg shadow-elevation-2 overflow-hidden animate-pulse">
        <div className="flex flex-col md:flex-row">
          <div className="w-full md:w-80 h-48 md:h-64 bg-muted flex-shrink-0" />
          
          <div className="flex-1 p-4 md:p-6">
            <div className="flex flex-col md:flex-row md:items-start md:justify-between gap-4">
              <div className="flex-1 space-y-4">
                <div className="h-8 bg-muted rounded w-3/4" />
                <div className="h-4 bg-muted rounded w-full" />
                <div className="h-4 bg-muted rounded w-5/6" />
                
                <div className="grid grid-cols-2 md:grid-cols-4 gap-3">
                  {[1, 2, 3, 4]?.map((i) => (
                    <div key={i} className="h-6 bg-muted rounded" />
                  ))}
                </div>
                
                <div className="h-6 bg-muted rounded w-48" />
              </div>
              
              <div className="flex flex-col items-end space-y-3 md:ml-6">
                <div className="h-10 bg-muted rounded w-24" />
                <div className="h-12 bg-muted rounded w-40" />
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }

  return (
    <div className="bg-card rounded-lg shadow-elevation-2 overflow-hidden animate-pulse h-full flex flex-col">
      <div className="w-full h-48 md:h-56 bg-muted flex-shrink-0" />
      <div className="p-4 md:p-5 flex-1 flex flex-col">
        <div className="h-6 bg-muted rounded w-3/4 mb-3" />
        <div className="h-4 bg-muted rounded w-full mb-2" />
        <div className="h-4 bg-muted rounded w-5/6 mb-4" />
        
        <div className="space-y-2 mb-4">
          {[1, 2, 3, 4]?.map((i) => (
            <div key={i} className="h-5 bg-muted rounded" />
          ))}
        </div>
        
        <div className="h-6 bg-muted rounded w-32 mb-4" />
        
        <div className="flex items-center justify-between pt-4 border-t border-border mt-auto">
          <div className="h-8 bg-muted rounded w-20" />
          <div className="h-10 bg-muted rounded w-32" />
        </div>
      </div>
    </div>
  );
};

export default SkeletonCard;